// extracted by mini-css-extract-plugin
export default {"chip":"Chip_chip__N1i+t","inProgress":"Chip_inProgress__JMJyG"};